import React from 'react';
import PropTypes from 'prop-types';
import {Alert} from '../../look';

const ErrorMessage = ({children, ...props}) => {
  if (!children || !children.message) {
    return null;
  }

  return <Alert {...props}>{children.message}</Alert>;
};

ErrorMessage.propTypes = {
  children: PropTypes.any,
};

export default ErrorMessage;
